import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IToasterConfig as ToastConfig } from 'angular2-toaster';
import { clearToast, showToast } from './toaster.actions';
import { GLOBAL_CONTAINER_ID } from './toaster.data';

@Injectable()
export class ToasterDispatcher {
  constructor(private _store: Store<any>) {}

  showToast(toastConfig: ToastConfig) {
    this._store.dispatch(showToast(toastConfig));
  }

  clearToast(toastId: string, toastContainerId: number = GLOBAL_CONTAINER_ID) {
    this._store.dispatch(clearToast(toastId, toastContainerId));
  }
}
